import { ReportProps } from '@wix/fe-essentials/bi';

export type ReportBI = (reportProps: ReportProps) => void;
